import React from 'react';
import { clearPreviewStates, updatePreviewState } from '../usePreviewState';
import { usePrevious } from '../usePrevious';
/*
 * usePreviewState for modal case (element might not exist)
 */
export function useModalPreviewState(modal, compPreviewState, stateMap) {
    const previewState = usePrevious(compPreviewState);
    React.useLayoutEffect(() => {
        if (modal) {
            if (previewState !== compPreviewState) {
                clearPreviewStates(modal, stateMap?.[previewState || '']);
            }
            updatePreviewState(compPreviewState, modal, stateMap?.[compPreviewState || '']);
        }
    }, [compPreviewState, stateMap, previewState, modal]);
}
//# sourceMappingURL=useModalPreviewState.js.map